var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 211,
    viewBox: "0 0 500 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155527_66177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.190626 135.113C0.0887378 134.147 0.847679 133.306 1.82097 133.306H85.0639C86.0377 133.306 86.7967 134.147 86.6943 135.113L78.843 209.535C78.7552 210.368 78.0516 211 77.2127 211H9.67254C8.83361 211 8.13005 210.368 8.04222 209.535L0.190626 135.113Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0492 133.306H59.0164L56.8821 102.052C56.3859 94.7849 50.333 89.1436 43.0328 89.1436C35.7325 89.1436 29.6797 94.7849 29.1834 102.052L27.0492 133.306Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0492 133.306H59.0164L56.8821 102.052C56.3859 94.7849 50.333 89.1436 43.0328 89.1436C35.7325 89.1436 29.6797 94.7849 29.1834 102.052L27.0492 133.306Z",
    fill: "url(#paint0_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 3.27132C304.918 1.46462 306.386 0 308.197 0H462.295C464.106 0 465.574 1.46462 465.574 3.27132V31.8953C465.574 33.702 464.106 35.1667 462.295 35.1667H308.197C306.386 35.1667 304.918 33.702 304.918 31.8953V3.27132Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 3.27132C304.918 1.46462 306.386 0 308.197 0H462.295C464.106 0 465.574 1.46462 465.574 3.27132V31.8953C465.574 33.702 464.106 35.1667 462.295 35.1667H308.197C306.386 35.1667 304.918 33.702 304.918 31.8953V3.27132Z",
    fill: "url(#paint1_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.934 24.126V10.6318H315.574V24.126H313.934Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.852 24.126V10.6318H320.492V24.126H318.852Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.77 24.126V10.6318H325.41V24.126H323.77Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.689 24.126V10.6318H330.328V24.126H328.689Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.607 24.126V10.6318H335.246V24.126H333.607Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.525 24.126V10.6318H340.164V24.126H338.525Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.443 24.126V10.6318H345.082V24.126H343.443Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.361 24.126V10.6318H350V24.126H348.361Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.279 24.126V10.6318H354.918V24.126H353.279Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.197 24.126V10.6318H359.836V24.126H358.197Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.115 24.126V10.6318H364.754V24.126H363.115Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.033 24.126V10.6318H369.672V24.126H368.033Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.951 24.126V10.6318H374.59V24.126H372.951Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.869 24.126V10.6318H379.508V24.126H377.869Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.787 24.126V10.6318H384.426V24.126H382.787Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.705 24.126V10.6318H389.344V24.126H387.705Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.393 20.4455C417.752 20.4455 418.852 19.3471 418.852 17.992C418.852 16.637 417.752 15.5385 416.393 15.5385C415.035 15.5385 413.934 16.637 413.934 17.992C413.934 19.3471 415.035 20.4455 416.393 20.4455ZM416.393 21.2633C418.204 21.2633 419.672 19.7987 419.672 17.992C419.672 16.1854 418.204 14.7207 416.393 14.7207C414.583 14.7207 413.115 16.1854 413.115 17.992C413.115 19.7987 414.583 21.2633 416.393 21.2633Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.426 17.992C434.426 19.7987 432.958 21.2633 431.148 21.2633C429.337 21.2633 427.869 19.7987 427.869 17.992C427.869 16.1854 429.337 14.7207 431.148 14.7207C432.958 14.7207 434.426 16.1854 434.426 17.992Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.18 17.992C449.18 19.7987 447.712 21.2633 445.902 21.2633C444.091 21.2633 442.623 19.7987 442.623 17.992C442.623 16.1854 444.091 14.7207 445.902 14.7207C447.712 14.7207 449.18 16.1854 449.18 17.992Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.949 19.9423C471.607 19.1897 470.13 18.8697 469.208 18.8083L469.317 17.1763C470.443 17.2513 472.165 17.6264 473.752 18.5163C475.351 19.4123 476.873 20.8674 477.434 23.1099C477.898 24.96 478.248 27.7715 478.623 30.7735C478.757 31.8483 478.893 32.9475 479.04 34.0357C479.607 38.2584 480.314 42.3059 481.471 44.6149L480.005 45.3464C478.702 42.7486 477.975 38.4133 477.415 34.2532C477.26 33.1009 477.118 31.9602 476.981 30.8617C476.612 27.904 476.282 25.2526 475.844 23.5066C475.422 21.8235 474.281 20.6888 472.949 19.9423Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.949 19.9423C471.607 19.1897 470.13 18.8697 469.208 18.8083L469.317 17.1763C470.443 17.2513 472.165 17.6264 473.752 18.5163C475.351 19.4123 476.873 20.8674 477.434 23.1099C477.898 24.96 478.248 27.7715 478.623 30.7735C478.757 31.8483 478.893 32.9475 479.04 34.0357C479.607 38.2584 480.314 42.3059 481.471 44.6149L480.005 45.3464C478.702 42.7486 477.975 38.4133 477.415 34.2532C477.26 33.1009 477.118 31.9602 476.981 30.8617C476.612 27.904 476.282 25.2526 475.844 23.5066C475.422 21.8235 474.281 20.6888 472.949 19.9423Z",
    fill: "url(#paint2_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.279 67.9059C477.963 58.1267 472.114 53.974 469.424 53.1201L469.921 51.5615C473.243 52.6159 479.579 57.3504 479.918 67.8533C480.089 73.1507 482.023 78.6726 484.234 84.9871C484.602 86.0397 484.979 87.1143 485.356 88.2134C487.976 95.852 490.574 104.543 490.574 114.905H488.934C488.934 104.82 486.41 96.3369 483.805 88.7434C483.436 87.6688 483.065 86.6097 482.698 85.5637C480.492 79.272 478.46 73.4757 478.279 67.9059Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.279 67.9059C477.963 58.1267 472.114 53.974 469.424 53.1201L469.921 51.5615C473.243 52.6159 479.579 57.3504 479.918 67.8533C480.089 73.1507 482.023 78.6726 484.234 84.9871C484.602 86.0397 484.979 87.1143 485.356 88.2134C487.976 95.852 490.574 104.543 490.574 114.905H488.934C488.934 104.82 486.41 96.3369 483.805 88.7434C483.436 87.6688 483.065 86.6097 482.698 85.5637C480.492 79.272 478.46 73.4757 478.279 67.9059Z",
    fill: "url(#paint3_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.778 90.4275C471.446 89.3676 469.891 89.0838 468.901 89.1419L468.804 87.5095C470.137 87.431 472.107 87.8014 473.8 89.1484C475.523 90.5175 476.875 92.8295 477.048 96.4655C477.252 100.747 477.661 106.732 478.827 112.704C479.998 118.694 481.914 124.578 485.079 128.722C487.821 132.314 489.693 138.302 490.935 144.199C492.185 150.134 492.825 156.125 493.032 159.84L491.395 159.931C491.192 156.286 490.561 150.378 489.331 144.536C488.093 138.657 486.277 132.99 483.775 129.713C480.381 125.269 478.404 119.09 477.218 113.017C476.029 106.926 475.616 100.848 475.411 96.5432C475.257 93.3087 474.081 91.4637 472.778 90.4275Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.778 90.4275C471.446 89.3676 469.891 89.0838 468.901 89.1419L468.804 87.5095C470.137 87.431 472.107 87.8014 473.8 89.1484C475.523 90.5175 476.875 92.8295 477.048 96.4655C477.252 100.747 477.661 106.732 478.827 112.704C479.998 118.694 481.914 124.578 485.079 128.722C487.821 132.314 489.693 138.302 490.935 144.199C492.185 150.134 492.825 156.125 493.032 159.84L491.395 159.931C491.192 156.286 490.561 150.378 489.331 144.536C488.093 138.657 486.277 132.99 483.775 129.713C480.381 125.269 478.404 119.09 477.218 113.017C476.029 106.926 475.616 100.848 475.411 96.5432C475.257 93.3087 474.081 91.4637 472.778 90.4275Z",
    fill: "url(#paint4_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.807 126.228C470.854 125.173 469.98 124.518 469.344 124.242L469.998 122.742C470.934 123.148 471.993 123.989 473.025 125.133C474.069 126.288 475.127 127.798 476.048 129.603C477.889 133.213 479.192 138.035 478.684 143.603C478.182 149.119 476.673 152.645 474.928 154.968C473.181 157.294 471.246 158.344 470.055 158.973L469.288 157.527C470.419 156.93 472.091 156.017 473.616 153.987C475.143 151.955 476.57 148.734 477.052 143.455C477.528 138.228 476.304 133.713 474.586 130.345C473.727 128.659 472.748 127.27 471.807 126.228Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.807 126.228C470.854 125.173 469.98 124.518 469.344 124.242L469.998 122.742C470.934 123.148 471.993 123.989 473.025 125.133C474.069 126.288 475.127 127.798 476.048 129.603C477.889 133.213 479.192 138.035 478.684 143.603C478.182 149.119 476.673 152.645 474.928 154.968C473.181 157.294 471.246 158.344 470.055 158.973L469.288 157.527C470.419 156.93 472.091 156.017 473.616 153.987C475.143 151.955 476.57 148.734 477.052 143.455C477.528 138.228 476.304 133.713 474.586 130.345C473.727 128.659 472.748 127.27 471.807 126.228Z",
    fill: "url(#paint5_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.226 195.809C472.09 194.93 470.045 194.643 468.852 194.643V193.008C470.256 193.008 472.513 193.335 474.852 194.296C477.196 195.26 479.667 196.883 481.42 199.505C481.568 199.727 481.712 199.945 481.853 200.158C483.246 202.261 484.366 203.952 486.498 205.341C488.853 206.875 492.519 208.076 499.262 208.751L499.098 210.379C492.258 209.693 488.283 208.457 485.602 206.711C483.173 205.128 481.871 203.157 480.497 201.078C480.351 200.857 480.205 200.636 480.056 200.413C478.53 198.129 476.357 196.685 474.226 195.809Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.226 195.809C472.09 194.93 470.045 194.643 468.852 194.643V193.008C470.256 193.008 472.513 193.335 474.852 194.296C477.196 195.26 479.667 196.883 481.42 199.505C481.568 199.727 481.712 199.945 481.853 200.158C483.246 202.261 484.366 203.952 486.498 205.341C488.853 206.875 492.519 208.076 499.262 208.751L499.098 210.379C492.258 209.693 488.283 208.457 485.602 206.711C483.173 205.128 481.871 203.157 480.497 201.078C480.351 200.857 480.205 200.636 480.056 200.413C478.53 198.129 476.357 196.685 474.226 195.809Z",
    fill: "url(#paint6_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 38.4378C304.918 36.6312 306.386 35.1665 308.197 35.1665H462.295C464.106 35.1665 465.574 36.6312 465.574 38.4378V67.0618C465.574 68.8685 464.106 70.3332 462.295 70.3332H308.197C306.386 70.3332 304.918 68.8685 304.918 67.0618V38.4378Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 38.4378C304.918 36.6312 306.386 35.1665 308.197 35.1665H462.295C464.106 35.1665 465.574 36.6312 465.574 38.4378V67.0618C465.574 68.8685 464.106 70.3332 462.295 70.3332H308.197C306.386 70.3332 304.918 68.8685 304.918 67.0618V38.4378Z",
    fill: "url(#paint7_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.934 59.2925V45.7983H315.574V59.2925H313.934Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.852 59.2925V45.7983H320.492V59.2925H318.852Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.77 59.2925V45.7983H325.41V59.2925H323.77Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.689 59.2925V45.7983H330.328V59.2925H328.689Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.607 59.2925V45.7983H335.246V59.2925H333.607Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.525 59.2925V45.7983H340.164V59.2925H338.525Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.443 59.2925V45.7983H345.082V59.2925H343.443Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.361 59.2925V45.7983H350V59.2925H348.361Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.279 59.2925V45.7983H354.918V59.2925H353.279Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.197 59.2925V45.7983H359.836V59.2925H358.197Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.115 59.2925V45.7983H364.754V59.2925H363.115Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.033 59.2925V45.7983H369.672V59.2925H368.033Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.951 59.2925V45.7983H374.59V59.2925H372.951Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.869 59.2925V45.7983H379.508V59.2925H377.869Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.787 59.2925V45.7983H384.426V59.2925H382.787Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.705 59.2925V45.7983H389.344V59.2925H387.705Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.672 53.159C419.672 54.9657 418.204 56.4303 416.393 56.4303C414.583 56.4303 413.115 54.9657 413.115 53.159C413.115 51.3523 414.583 49.8877 416.393 49.8877C418.204 49.8877 419.672 51.3523 419.672 53.159Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.148 55.6125C432.506 55.6125 433.607 54.5141 433.607 53.159C433.607 51.804 432.506 50.7055 431.148 50.7055C429.789 50.7055 428.689 51.804 428.689 53.159C428.689 54.5141 429.789 55.6125 431.148 55.6125ZM431.148 56.4303C432.958 56.4303 434.426 54.9657 434.426 53.159C434.426 51.3523 432.958 49.8877 431.148 49.8877C429.337 49.8877 427.869 51.3523 427.869 53.159C427.869 54.9657 429.337 56.4303 431.148 56.4303Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.902 55.6125C447.26 55.6125 448.361 54.5141 448.361 53.159C448.361 51.804 447.26 50.7055 445.902 50.7055C444.543 50.7055 443.443 51.804 443.443 53.159C443.443 54.5141 444.543 55.6125 445.902 55.6125ZM445.902 56.4303C447.712 56.4303 449.18 54.9657 449.18 53.159C449.18 51.3523 447.712 49.8877 445.902 49.8877C444.091 49.8877 442.623 51.3523 442.623 53.159C442.623 54.9657 444.091 56.4303 445.902 56.4303Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 73.6048C304.918 71.7981 306.386 70.3335 308.197 70.3335H462.295C464.106 70.3335 465.574 71.7981 465.574 73.6048V102.229C465.574 104.035 464.106 105.5 462.295 105.5H308.197C306.386 105.5 304.918 104.035 304.918 102.229V73.6048Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 73.6048C304.918 71.7981 306.386 70.3335 308.197 70.3335H462.295C464.106 70.3335 465.574 71.7981 465.574 73.6048V102.229C465.574 104.035 464.106 105.5 462.295 105.5H308.197C306.386 105.5 304.918 104.035 304.918 102.229V73.6048Z",
    fill: "url(#paint8_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.934 94.4595V80.9653H315.574V94.4595H313.934Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.852 94.4595V80.9653H320.492V94.4595H318.852Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.77 94.4595V80.9653H325.41V94.4595H323.77Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.689 94.4595V80.9653H330.328V94.4595H328.689Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.607 94.4595V80.9653H335.246V94.4595H333.607Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.525 94.4595V80.9653H340.164V94.4595H338.525Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.443 94.4595V80.9653H345.082V94.4595H343.443Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.361 94.4595V80.9653H350V94.4595H348.361Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.279 94.4595V80.9653H354.918V94.4595H353.279Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.197 94.4595V80.9653H359.836V94.4595H358.197Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.115 94.4595V80.9653H364.754V94.4595H363.115Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.033 94.4595V80.9653H369.672V94.4595H368.033Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.951 94.4595V80.9653H374.59V94.4595H372.951Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.869 94.4595V80.9653H379.508V94.4595H377.869Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.787 94.4595V80.9653H384.426V94.4595H382.787Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.705 94.4595V80.9653H389.344V94.4595H387.705Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.672 88.3255C419.672 90.1321 418.204 91.5968 416.393 91.5968C414.583 91.5968 413.115 90.1321 413.115 88.3255C413.115 86.5189 414.583 85.0542 416.393 85.0542C418.204 85.0542 419.672 86.5189 419.672 88.3255Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.426 88.3255C434.426 90.1321 432.958 91.5968 431.148 91.5968C429.337 91.5968 427.869 90.1321 427.869 88.3255C427.869 86.5189 429.337 85.0542 431.148 85.0542C432.958 85.0542 434.426 86.5189 434.426 88.3255Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.902 90.779C447.26 90.779 448.361 89.6807 448.361 88.3255C448.361 86.9704 447.26 85.872 445.902 85.872C444.543 85.872 443.443 86.9704 443.443 88.3255C443.443 89.6807 444.543 90.779 445.902 90.779ZM445.902 91.5968C447.712 91.5968 449.18 90.1321 449.18 88.3255C449.18 86.5189 447.712 85.0542 445.902 85.0542C444.091 85.0542 442.623 86.5189 442.623 88.3255C442.623 90.1321 444.091 91.5968 445.902 91.5968Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 108.771C304.918 106.965 306.386 105.5 308.197 105.5H462.295C464.106 105.5 465.574 106.965 465.574 108.771V137.395C465.574 139.202 464.106 140.667 462.295 140.667H308.197C306.386 140.667 304.918 139.202 304.918 137.395V108.771Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 108.771C304.918 106.965 306.386 105.5 308.197 105.5H462.295C464.106 105.5 465.574 106.965 465.574 108.771V137.395C465.574 139.202 464.106 140.667 462.295 140.667H308.197C306.386 140.667 304.918 139.202 304.918 137.395V108.771Z",
    fill: "url(#paint9_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.934 129.626V116.132H315.574V129.626H313.934Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.852 129.626V116.132H320.492V129.626H318.852Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.77 129.626V116.132H325.41V129.626H323.77Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.689 129.626V116.132H330.328V129.626H328.689Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.607 129.626V116.132H335.246V129.626H333.607Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.525 129.626V116.132H340.164V129.626H338.525Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.443 129.626V116.132H345.082V129.626H343.443Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.361 129.626V116.132H350V129.626H348.361Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.279 129.626V116.132H354.918V129.626H353.279Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.197 129.626V116.132H359.836V129.626H358.197Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.115 129.626V116.132H364.754V129.626H363.115Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.033 129.626V116.132H369.672V129.626H368.033Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.951 129.626V116.132H374.59V129.626H372.951Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.869 129.626V116.132H379.508V129.626H377.869Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.787 129.626V116.132H384.426V129.626H382.787Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.705 129.626V116.132H389.344V129.626H387.705Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.393 125.946C417.752 125.946 418.852 124.847 418.852 123.492C418.852 122.137 417.752 121.039 416.393 121.039C415.035 121.039 413.934 122.137 413.934 123.492C413.934 124.847 415.035 125.946 416.393 125.946ZM416.393 126.763C418.204 126.763 419.672 125.299 419.672 123.492C419.672 121.685 418.204 120.221 416.393 120.221C414.583 120.221 413.115 121.685 413.115 123.492C413.115 125.299 414.583 126.763 416.393 126.763Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.426 123.492C434.426 125.299 432.958 126.763 431.148 126.763C429.337 126.763 427.869 125.299 427.869 123.492C427.869 121.685 429.337 120.221 431.148 120.221C432.958 120.221 434.426 121.685 434.426 123.492Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.18 123.492C449.18 125.299 447.712 126.763 445.902 126.763C444.091 126.763 442.623 125.299 442.623 123.492C442.623 121.685 444.091 120.221 445.902 120.221C447.712 120.221 449.18 121.685 449.18 123.492Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 143.938C304.918 142.131 306.386 140.667 308.197 140.667H462.295C464.106 140.667 465.574 142.131 465.574 143.938V172.562C465.574 174.368 464.106 175.833 462.295 175.833H308.197C306.386 175.833 304.918 174.368 304.918 172.562V143.938Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 143.938C304.918 142.131 306.386 140.667 308.197 140.667H462.295C464.106 140.667 465.574 142.131 465.574 143.938V172.562C465.574 174.368 464.106 175.833 462.295 175.833H308.197C306.386 175.833 304.918 174.368 304.918 172.562V143.938Z",
    fill: "url(#paint10_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.934 164.793V151.298H315.574V164.793H313.934Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.852 164.793V151.298H320.492V164.793H318.852Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.77 164.793V151.298H325.41V164.793H323.77Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.689 164.793V151.298H330.328V164.793H328.689Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.607 164.793V151.298H335.246V164.793H333.607Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.525 164.793V151.298H340.164V164.793H338.525Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.443 164.793V151.298H345.082V164.793H343.443Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.361 164.793V151.298H350V164.793H348.361Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.279 164.793V151.298H354.918V164.793H353.279Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.197 164.793V151.298H359.836V164.793H358.197Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.115 164.793V151.298H364.754V164.793H363.115Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.033 164.793V151.298H369.672V164.793H368.033Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.951 164.793V151.298H374.59V164.793H372.951Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.869 164.793V151.298H379.508V164.793H377.869Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.787 164.793V151.298H384.426V164.793H382.787Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.705 164.793V151.298H389.344V164.793H387.705Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.672 158.659C419.672 160.466 418.204 161.93 416.393 161.93C414.583 161.93 413.115 160.466 413.115 158.659C413.115 156.852 414.583 155.388 416.393 155.388C418.204 155.388 419.672 156.852 419.672 158.659Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.148 161.113C432.506 161.113 433.607 160.014 433.607 158.659C433.607 157.304 432.506 156.206 431.148 156.206C429.789 156.206 428.689 157.304 428.689 158.659C428.689 160.014 429.789 161.113 431.148 161.113ZM431.148 161.93C432.958 161.93 434.426 160.466 434.426 158.659C434.426 156.852 432.958 155.388 431.148 155.388C429.337 155.388 427.869 156.852 427.869 158.659C427.869 160.466 429.337 161.93 431.148 161.93Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.18 158.659C449.18 160.466 447.712 161.93 445.902 161.93C444.091 161.93 442.623 160.466 442.623 158.659C442.623 156.852 444.091 155.388 445.902 155.388C447.712 155.388 449.18 156.852 449.18 158.659Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 179.105C304.918 177.298 306.386 175.833 308.197 175.833H462.295C464.106 175.833 465.574 177.298 465.574 179.105V207.729C465.574 209.535 464.106 211 462.295 211H308.197C306.386 211 304.918 209.535 304.918 207.729V179.105Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.918 179.105C304.918 177.298 306.386 175.833 308.197 175.833H462.295C464.106 175.833 465.574 177.298 465.574 179.105V207.729C465.574 209.535 464.106 211 462.295 211H308.197C306.386 211 304.918 209.535 304.918 207.729V179.105Z",
    fill: "url(#paint11_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.934 199.96V186.465H315.574V199.96H313.934Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.852 199.96V186.465H320.492V199.96H318.852Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.77 199.96V186.465H325.41V199.96H323.77Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.689 199.96V186.465H330.328V199.96H328.689Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.607 199.96V186.465H335.246V199.96H333.607Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.525 199.96V186.465H340.164V199.96H338.525Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.443 199.96V186.465H345.082V199.96H343.443Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.361 199.96V186.465H350V199.96H348.361Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.279 199.96V186.465H354.918V199.96H353.279Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.197 199.96V186.465H359.836V199.96H358.197Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.115 199.96V186.465H364.754V199.96H363.115Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.033 199.96V186.465H369.672V199.96H368.033Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.951 199.96V186.465H374.59V199.96H372.951Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.869 199.96V186.465H379.508V199.96H377.869Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.787 199.96V186.465H384.426V199.96H382.787Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.705 199.96V186.465H389.344V199.96H387.705Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.393 196.279C417.752 196.279 418.852 195.181 418.852 193.826C418.852 192.47 417.752 191.372 416.393 191.372C415.035 191.372 413.934 192.47 413.934 193.826C413.934 195.181 415.035 196.279 416.393 196.279ZM416.393 197.097C418.204 197.097 419.672 195.632 419.672 193.826C419.672 192.019 418.204 190.554 416.393 190.554C414.583 190.554 413.115 192.019 413.115 193.826C413.115 195.632 414.583 197.097 416.393 197.097Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.426 193.826C434.426 195.632 432.958 197.097 431.148 197.097C429.337 197.097 427.869 195.632 427.869 193.826C427.869 192.019 429.337 190.554 431.148 190.554C432.958 190.554 434.426 192.019 434.426 193.826Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.902 196.279C447.26 196.279 448.361 195.181 448.361 193.826C448.361 192.47 447.26 191.372 445.902 191.372C444.543 191.372 443.443 192.47 443.443 193.826C443.443 195.181 444.543 196.279 445.902 196.279ZM445.902 197.097C447.712 197.097 449.18 195.632 449.18 193.826C449.18 192.019 447.712 190.554 445.902 190.554C444.091 190.554 442.623 192.019 442.623 193.826C442.623 195.632 444.091 197.097 445.902 197.097Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.574 13.9033H468.852C469.758 13.9033 470.492 14.6356 470.492 15.539V20.446C470.492 21.3493 469.758 22.0816 468.852 22.0816H465.574V13.9033Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.574 48.252H468.852C469.758 48.252 470.492 48.9842 470.492 49.8876V54.7946C470.492 55.698 469.758 56.4302 468.852 56.4302H465.574V48.252Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.574 84.2363H468.852C469.758 84.2363 470.492 84.9683 470.492 85.872V90.779C470.492 91.6827 469.758 92.4146 468.852 92.4146H465.574V84.2363Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.574 119.403H468.852C469.758 119.403 470.492 120.135 470.492 121.039V125.946C470.492 126.85 469.758 127.582 468.852 127.582H465.574V119.403Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.574 153.752H468.852C469.758 153.752 470.492 154.484 470.492 155.388V160.295C470.492 161.198 469.758 161.93 468.852 161.93H465.574V153.752Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.574 189.736H468.852C469.758 189.736 470.492 190.468 470.492 191.372V196.279C470.492 197.183 469.758 197.915 468.852 197.915H465.574V189.736Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.491 52.1163L478.311 49.2539L479.887 49.7032L479.067 52.5656L477.491 52.1163Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.984 51.6837L481.574 49.6391L483.181 49.3184L483.591 51.3629L481.984 51.6837Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.373 48.8905L484.324 47.2548L485.348 45.9775L487.397 47.6132L486.373 48.8905Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.606 118.483L486.245 116.438L487.525 117.461L485.885 119.505L484.606 118.483Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.344 120.63V117.358H490.984V120.63H489.344Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.56 119.414L492.33 117.37L493.736 116.528L494.966 118.573L493.56 119.414Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.229 164.302L488.688 161.031L489.999 162.012L487.54 165.283L486.229 164.302Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.216 167.327L491.807 163.238L493.438 163.075L493.848 167.164L492.216 167.327Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.859 164.02L496.039 162.793L497.403 161.885L498.223 163.112L496.859 164.02Z",
    fill: "#C8D8FA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.541 202.822H57.377C56.4717 202.822 55.7377 203.554 55.7377 204.457V209.364C55.7377 210.268 56.4717 211 57.377 211H347.541C348.446 211 349.18 210.268 349.18 209.364V204.457C349.18 203.554 348.446 202.822 347.541 202.822Z",
    fill: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6721 41.7094C69.6721 40.806 70.4061 40.0737 71.3115 40.0737H332.787C333.693 40.0737 334.426 40.806 334.426 41.7094V202.822H69.6721V41.7094Z",
    fill: "#D6E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6721 41.7094C69.6721 40.806 70.4061 40.0737 71.3115 40.0737H332.787C333.693 40.0737 334.426 40.806 334.426 41.7094V202.822H69.6721V41.7094Z",
    fill: "url(#paint12_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4426 41.7091C68.4426 40.1282 69.727 38.8467 71.3115 38.8467H332.787C334.371 38.8467 335.656 40.1282 335.656 41.7091V202.821H333.197V41.7091C333.197 41.4833 333.013 41.3002 332.787 41.3002H71.3115C71.0852 41.3002 70.9016 41.4833 70.9016 41.7091V202.821H68.4426V41.7091Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4426 41.7091C68.4426 40.1282 69.727 38.8467 71.3115 38.8467H332.787C334.371 38.8467 335.656 40.1282 335.656 41.7091V202.821H333.197V41.7091C333.197 41.4833 333.013 41.3002 332.787 41.3002H71.3115C71.0852 41.3002 70.9016 41.4833 70.9016 41.7091V202.821H68.4426V41.7091Z",
    fill: "url(#paint13_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.213 202.822H236.885V206.093C236.885 206.997 236.152 207.729 235.246 207.729H168.852C167.947 207.729 167.213 206.997 167.213 206.093V202.822Z",
    fill: "url(#paint14_linear_155527_66177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.516 71.048C194.996 68.576 197.669 67.062 200.554 67.062H202.725C205.61 67.062 208.283 68.576 209.762 71.048L265.548 164.281C268.811 169.731 264.874 176.651 258.511 176.651H144.768C138.405 176.651 134.468 169.731 137.73 164.281L193.516 71.048Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.267 104.682L204.779 140.592H199.106L198.616 104.682H205.267ZM201.942 155.034C200.736 155.034 199.701 154.603 198.837 153.741C197.973 152.879 197.541 151.846 197.541 150.643C197.541 149.439 197.973 148.407 198.837 147.545C199.701 146.683 200.736 146.252 201.942 146.252C203.148 146.252 204.184 146.683 205.048 147.545C205.911 148.407 206.343 149.439 206.343 150.643C206.343 151.44 206.139 152.172 205.732 152.839C205.341 153.506 204.811 154.042 204.143 154.449C203.491 154.84 202.757 155.034 201.942 155.034Z",
    fill: "#D6E2FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155527_66177",
    x1: 43.0328,
    y1: 181.558,
    x2: 43.0328,
    y2: 89.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D8FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_155527_66177",
    x1: 385.246,
    y1: 52.75,
    x2: 385.246,
    y2: 17.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D8FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_155527_66177",
    x1: 475,
    y1: 17.9923,
    x2: 477.497,
    y2: 35.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AB7F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_155527_66177",
    x1: 479.713,
    y1: 52.3408,
    x2: 487.262,
    y2: 91.1943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AB7F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_155527_66177",
    x1: 480.533,
    y1: 88.3175,
    x2: 489.035,
    y2: 132.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AB7F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_155527_66177",
    x1: 473.823,
    y1: 123.492,
    x2: 479.298,
    y2: 144.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AB7F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_155527_66177",
    x1: 484.016,
    y1: 193.826,
    x2: 484.344,
    y2: 203.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AB7F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_155527_66177",
    x1: 385.246,
    y1: 87.9165,
    x2: 385.246,
    y2: 53.1587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D8FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_155527_66177",
    x1: 385.246,
    y1: 123.083,
    x2: 385.246,
    y2: 88.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D8FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_155527_66177",
    x1: 385.246,
    y1: 158.25,
    x2: 385.246,
    y2: 123.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D8FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_155527_66177",
    x1: 385.246,
    y1: 193.416,
    x2: 385.246,
    y2: 158.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D8FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_155527_66177",
    x1: 385.246,
    y1: 228.583,
    x2: 385.246,
    y2: 193.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D8FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_155527_66177",
    x1: 202.049,
    y1: -114.496,
    x2: 202.049,
    y2: 202.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AB7F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_155527_66177",
    x1: 202.049,
    y1: -14.7211,
    x2: 202.049,
    y2: 202.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AB7F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_155527_66177",
    x1: 202.049,
    y1: 225.823,
    x2: 202.049,
    y2: 202.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2563EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155527_66177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 211,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.e6e850a9945dc931881a12822da649b3.svg";
export { ForwardRef as ReactComponent };